module.exports = __webpack_public_path__ + "static/media/icon-mongoDb.0dc851f0.svg";